import React from "react";
import { Thumbnail } from "@culturehq/components";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";
import getUserName from "app/utils/getUserName";

const Recognizer = ({ user }) => (
  <div className="recognitions__recognizer">
    <span className="from">
      <Trans>From: </Trans>
    </span>
    <Thumbnail className="Thumbnail" image={user.avatar.thumbUrl} title={getUserName(user)} />
    <ProfileLink user={user} />
  </div>
);

export default Recognizer;
